import { DataSource } from '@angular/cdk/table';
import { CollectionViewer } from '@angular/cdk/collections';
import { Observable, BehaviorSubject, of } from "rxjs";
import { catchError, finalize } from "rxjs/operators";
import { MeetingResponse, PaginationMeetingResponse } from '../models/basicMeetingModel';
import { DashboardService } from './dashboard.service';

export class MeetingDataSource implements DataSource<MeetingResponse>{
 
    private meetingSubject = new BehaviorSubject<MeetingResponse[]>([]);
    private loadingSubject = new BehaviorSubject<boolean>(false);
    public countSubject = new BehaviorSubject<number>(0);
    public loading$ = this.loadingSubject.asObservable();
    public counter$ = this.countSubject.asObservable();
    public totalCount:any;
    constructor(private dashboardService: DashboardService) { }

    connect(collectionViewer: CollectionViewer): Observable<MeetingResponse[]> {
        return this.meetingSubject.asObservable();
    }

    disconnect(collectionViewer: CollectionViewer): void {
        this.meetingSubject.complete();
        this.loadingSubject.complete();
        this.countSubject.complete();
    }

    loadUpcomingMeetings(jsonReq:any) {
        this.loadingSubject.next(true);
        this.dashboardService.loadUpcomingMeetings(jsonReq)
            .pipe(
                catchError(() => of([])),
                finalize(() => this.loadingSubject.next(false))
            )
            .subscribe((result: PaginationMeetingResponse) => {
                this.meetingSubject.next(result.dataList);
                this.countSubject.next(result.totalCount);
                this.totalCount=result.totalCount;
            });
    }


    loadDocumentMeeting(jsonReq:any) {
        this.loadingSubject.next(true);
        this.dashboardService.loadDocumentMeeting(jsonReq)
            .pipe(
                catchError(() => of([])),
                finalize(() => this.loadingSubject.next(false))
            )
            .subscribe((result: PaginationMeetingResponse) => {
                this.meetingSubject.next(result.dataList);
                this.countSubject.next(result.totalCount);
                this.totalCount=result.totalCount;
            });
    }

     

    loadPastMeetings(jsonReq:any) {
        this.loadingSubject.next(true);
        this.dashboardService.loadPastMeetings(jsonReq)
            .pipe(
                catchError(() => of([])),
                finalize(() => this.loadingSubject.next(false))
            )
            .subscribe((result: PaginationMeetingResponse) => {
                this.meetingSubject.next(result.dataList);
                this.countSubject.next(result.totalCount);
                this.totalCount=result.totalCount;
            });
    }
    loadSearchMeetings(jsonReq:any) {
        this.loadingSubject.next(true);
        this.dashboardService.searchMeetings(jsonReq)
            .pipe(
                catchError(() => of([])),
                finalize(() => this.loadingSubject.next(false))
            )
            .subscribe((result: PaginationMeetingResponse) => {
                this.meetingSubject.next(result.dataList);
                this.countSubject.next(result.totalCount);
                this.totalCount=result.totalCount;
            });
    }
}
